'use client';

import { axiosInstance } from '@ae/data-access';
import { useGetApiEndpoint, useLocale, useRequestUrl } from '@ae/shared';

export const ApiProvider = ({ children }: { children: React.ReactElement }) => {
  const locale = useLocale();
  const requestUrl = useRequestUrl();
  const apiEndpoint = useGetApiEndpoint(requestUrl);

  axiosInstance.defaults.baseURL = `${apiEndpoint}`;
  axiosInstance.defaults.headers.common['X-LOCALE'] = locale;

  return children;
};
